<template>
    <main class="flex-1 overflow-y-auto focus:outline-none">
        <div class="py-6">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <div class="flex items-center justify-between">
                    <h1 class="text-2xl font-semibold text-gray-900">Detail FAQ</h1>
                    <div class="flex space-x-4">
                        <button @click="editFaq"
                            class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                            Upraviť
                        </button>
                        <button @click="goToList"
                            class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                            Späť na zoznam
                        </button>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                <div class="py-4">
                    <div v-if="loading" class="text-center py-4">
                        <div
                            class="mx-auto h-6 w-6 animate-spin rounded-full border-2 border-solid border-gray-300 border-t-teal-500">
                        </div>
                        <p class="mt-2 text-sm text-gray-500">Načítavanie...</p>
                    </div>
                    <div v-else-if="!faq" class="text-center py-8">
                        <p class="text-gray-500">FAQ sa nenašlo</p>
                        <button @click="goToList"
                            class="mt-4 inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500">
                            Späť na zoznam
                        </button>
                    </div>
                    <div v-else class="bg-white shadow overflow-hidden sm:rounded-lg">
                        <div class="px-4 py-5 sm:px-6">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">{{ faq.title }}</h3>
                            <p class="mt-1 max-w-2xl text-sm text-gray-500">FAQ podrobnosti</p>
                        </div>
                        <div class="border-t border-gray-200 px-4 py-5 sm:p-6">
                            <p class="text-sm text-gray-900 whitespace-pre-wrap">{{ faq.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import axiosClient from '../axios'
import type { Faq } from '../types'

const router = useRouter()
const route = useRoute()
const loading = ref(true)
const faq = ref<Faq | null>(null)

onMounted(async () => {
    await fetchFaq()
})

async function fetchFaq() {
    loading.value = true
    try {
        const response = await axiosClient.get(`/faqs/${route.params.id}/get`)
        if (response.data && response.data.success) {
            faq.value = response.data.data
        }
    } catch (error) {
        console.error('Error fetching FAQ:', error)
        faq.value = null
    } finally {
        loading.value = false
    }
}

function editFaq() {
    router.push({ name: 'Upraviť FAQ', params: { id: route.params.id } })
}

function goToList() {
    router.push({ name: 'Zoznam FAQ' })
}
</script>

<!-- Using global styles and Tailwind classes -->
